import React, { useState,useEffect } from 'react';
import api from './../../../API/Api.js';
import { Row, Col, Spinner, UncontrolledAlert} from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { Link } from 'react-router-dom';

const DeleteSuccess = () => {
    const [ image, setImage ] = useState('');
    const fileUpload = e => {
          setImage(e.target.files[0])
    }
    const handleValidSubmit = async (event, values) => {
             const formData = new FormData();
             formData.append("pic", image);
             formData.append("name", values.name);
            const resp = await api.post('create-file', formData, { headers: {'Content-Type': 'multipart/form-data' }})
    }
  return (
       <>
         <AvForm
                style={{position:'relative'}}
                className="form-horizontal mt-4"
                onValidSubmit={(e, v) => {
                handleValidSubmit(e, v)
                }}
                >
                     <Row>
                         <Col md={6}>
                         <AvField
                          name="name"
                          label="Name"
                          value=""
                          className="form-control"
                          placeholder="Enter Name"
                          type="text"
                          required
                        />
                         </Col>
                <Col md={6}>
                <AvField
                    name="pic"
                    label="Producer Pic"
                    value=""
                    className='form-control'
                    type="file"
                    onChange={(e) => fileUpload(e)}
                    required
                />
                </Col>
                </Row>
                <button className="btn btn-primary w-md waves-effect waves-light" type="submit">Submit</button>
                </AvForm>
       </>
  )
}

export default DeleteSuccess